import React from "react";

export default function TestimonialsBox({ testiData }) {
  const totalStars = 5;
  return (
    <>
      <div className="box">
        <div className="client-pic">
          <img src={testiData.image} alt="" className="img img-responsive" />
        </div>
        <div className="details">
          <h4>{testiData.name}</h4>
          {testiData.designation !== "" && (
            <p className="designation">({testiData.designation})</p>
          )}

          <div className="rating">
            {Array.from({ length: totalStars }, (_, index) => (
              <i
                key={index}
                className={`fa ${
                  index < testiData.rating ? "fa-star" : "fa-star-o"
                }`}
                style={{ color: "#f39c12", marginRight: "3px" }}
              ></i>
            ))}
          </div>
          <p>{testiData.tagline}</p>
        </div>
      </div>
    </>
  );
}
